export default __webpack_public_path__ + "static/Adam_Wilder_Resume-acdc574303f3ad0fb48caea6841f293b.pdf";